import script from "./DarkHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./DarkHeader.vue?vue&type=script&setup=true&lang=js"

import "./DarkHeader.vue?vue&type=style&index=0&id=282e324a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-282e324a"]])

export default __exports__